import { render, staticRenderFns } from "./elementEvent.vue?vue&type=template&id=32e537c9"
import script from "./elementEvent.vue?vue&type=script&lang=js"
export * from "./elementEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports